import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "preview", "placeholder", "filename" ]

  select() {
    this.inputTarget.click()
  }

  changed() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.classList.remove("hidden")
      this.previewTarget.querySelector("img").src = e.target.result
      if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
      if (this.hasFilenameTarget) this.filenameTarget.textContent = file.name
    }
    reader.readAsDataURL(file)
  }

  remove() {
    this.inputTarget.value = ""
    this.previewTarget.classList.add("hidden")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.remove("hidden")
    if (this.hasFilenameTarget) this.filenameTarget.textContent = ""
  }
}
